import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { eventBus } from '@/utils/EventBus';

@Component({})
export default class LayoutController extends Vue {

  @Prop({ required: true, type: Boolean })
  private isForEnglishPaper!: boolean;
  @Prop({ required: true, type: Number })
  private collapseAfter!: number;

  private verticalLayout: 'topdown' | 'bottomup' = 'topdown';
  private horizontalLayout: 'linearTidy' | 'radialTidy' = 'radialTidy';

  private isDepthChanged: boolean = false;

  private mounted() {
    eventBus.$on('handleDepthSliderEventEnd', () => {
      this.isDepthChanged = false;
    });
  }

  private async handleDepthSliderEvent(arg: number | Event) {
    if (Number.isInteger(arg as number)) { // handle v-on:input
      // this.collapseAfter = arg as number;
      this.$emit('collapseAfterChanged', arg);
      this.isDepthChanged = true;
    } else {
      switch ((arg as Event).type) {
        case 'click': // hande v-on:click
          if (!this.isDepthChanged) { return; }
          this.$emit('handleDepthSliderEvent');
          break;
      }
    }
  }

  @Watch('verticalLayout')
  private verticalLayoutChanged(verticalLayout: 'topdown' | 'bottomup') {
    this.$emit('verticalLayoutChanged', verticalLayout);
  }
  @Watch('horizontalLayout')
  private horizontalLayoutChanged(horizontalLayout: 'linearTidy' | 'radialTidy') {
    this.$emit('horizontalLayoutChanged', horizontalLayout);
  }
  // @Watch('collapseAfter')
  // private collapseAfterChanged(collapseAfter: number) {
  //   this.$emit('collpaseAfterChanged', collapseAfter);
  // }
}
